import { ConfigEditor } from "./ConfigEditor.js";
import { ExecutionView } from "./ExecutionView.js";
import { Icon } from "./Icon.js";
import { configSchema, dataSchema, defaultConfig } from "./schema.js";
/**
 * Basic Comment action type plugin.
 *
 * Displays markdown content to users and requires them to confirm they've read it.
 * This is the simplest action type - just shows information without collecting input.
 * @example
 * ```typescript
 * // Configuration set by admin:
 * {
 *   content: "# Welcome\\nPlease read the following instructions carefully..."
 * }
 *
 * // Data produced on completion:
 * {
 *   confirmationNote: "Understood" // optional note from user
 * }
 * ```
 */
export const commentBasicPlugin = {
    // Identity
    slug: "comment-basic",
    name: "Basic Comment",
    description: "Display text or markdown content to the user",
    // Classification
    type: "comment",
    completionType: "user_confirm",
    // Schemas
    configSchema,
    dataSchema,
    // Handlers
    handlers: {
        // No special handling needed for this simple action type.
        // The default behavior (mark as started/completed) is sufficient.
        onComplete: (ctx, data) => {
            ctx.logger.info("Comment action completed", {
                actionId: ctx.execution.moduleActionId,
                userId: ctx.userId,
                hasNote: !!data.confirmationNote,
            });
            return Promise.resolve();
        },
    },
    // Components
    components: {
        Icon,
        ConfigEditor,
        ExecutionView,
    },
    // Defaults
    defaultConfig,
    order: 0,
    // Metadata
    version: "1.0.0",
    author: "Unios Team",
};
//# sourceMappingURL=index.js.map